"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Translator = /** @class */ (function () {
    function Translator(t) {
        this.t = t;
    }
    Translator.prototype.translate = function (key, allowEmptyTranslation, interpolationValues) {
        var value = interpolationValues
            ? this.t(key, interpolationValues)
            : this.t(key);
        if (value === key) {
            return allowEmptyTranslation ? "" : "#".concat(key, "#");
        }
        return value;
    };
    return Translator;
}());
exports.default = Translator;
